import "./header.css";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const header = document.getElementById("header");
    document.addEventListener("scroll", () => {
      if (window.scrollY > 600) {
        header.classList.add("header_fixed");
      } else {
        header.classList.remove("header_fixed");
      }
    });
  },
  false
);
